module.exports = __webpack_public_path__ + "static/media/back.b7552759.jpg";